module.exports = __webpack_public_path__ + "static/hezrou-00d8605e49369e4746bd6962498ab97a.jpeg";